// @flow
import { SET_CURRENT_PAGE, SET_BREADSCRUM, SET_MENU_WIDTH } from "../actions/main"

let dataState = {
    currentPage: '',
    breadscrum: {},
    menuWidth: 0,
};

const MainReducer = (state = dataState, action) => {

    var newdata;

    switch (action.type) {

        case SET_CURRENT_PAGE:
            newdata = Object.assign({}, state);
            newdata.currentPage = action.payload;
            state = Object.assign({}, state, newdata);
            return state;

        case SET_BREADSCRUM:
            newdata = Object.assign({}, state);
            newdata.breadscrum[action.payload.page] = action.payload.paths;
            state = Object.assign({}, state, newdata);
            return state;

        case SET_MENU_WIDTH:
            newdata = Object.assign({}, state);
            newdata.menuWidth = action.payload;
            state = Object.assign({}, state, newdata);
            return state;

        default:
            return state;
    }
};

export default MainReducer;
